export default "__VITE_ASSET__BsIqz7$0__"